import React from 'react';
import { useNavigate } from 'react-router-dom';

import { HotelInfo, HotelInfoPublic } from '@/features/projects/projectsSlice';

import StatisticsPanel from './StatisticsPanel';

export interface ProjectStatisticsProps {
  project:				HotelInfo;
  pub:					HotelInfoPublic | null;
  // Fired with false when the server says the feature must not be shown at
  // all (503 not enabled server-wide, or 403 the read was refused) so the
  // parent can drop the tab — same contract as RoomScreenTime.onAvailability.
  onAvailability?:		(available: boolean) => void;
}

// Project-level Statistics tab: the full StatisticsPanel — room picker,
// rooms ranking and the embedded screen-time summary all on — with a deep
// link from the screen-time card into that room's own Statistics tab.
const ProjectStatistics = (props: ProjectStatisticsProps) => {
  const navigate = useNavigate();

  const projectId = props.project.id;

  const openRoom = React.useCallback((roomNo: string) => {
    navigate(`/projects/${encodeURIComponent(projectId)}/rooms/${encodeURIComponent(roomNo)}/statistics`);
  }, [navigate, projectId]);

  return (
  <StatisticsPanel projectId={projectId}
                    pub={props.pub}
                    onAvailability={props.onAvailability}
                    onOpenRoom={openRoom} />
  );
};

export default ProjectStatistics;
